import PropTypes from 'prop-types';
import React from 'react';
import RosettaFormattedMessage from '../../../../common/rosetta_formatted_message';
import { ArrowLeft } from '../../../../common/fa_icons';

const GoBackButton = ({ handleClick }) => (
  <div className="slideshow-nav">
    <a onClick={handleClick}>
      <div className="nav-left see-all-slides">
        <ArrowLeft />
      </div>
      <div className="slide-info left">
        <div className="slide-info-text">
          <RosettaFormattedMessage parentFilename={__filename}
            id="go_back"
            description='Call-to-action to close "See All Slides" view'
            defaultMessage="Go Back"
          />
        </div>
      </div>
    </a>
  </div>
);

GoBackButton.propTypes = {
  handleClick: PropTypes.func.isRequired
};

export default GoBackButton;
